<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
        <header-component :headerTitle="headerText" />
        <v-snackbar
            v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
            <v-layout align-center pr-4>
                <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
                <v-layout column>
                <div>{{ snackbar.text }}</div>
                </v-layout>
            </v-layout>
            <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
        <v-card class="v-card-100 mt-0">
        <v-card-title class="action-style pt-4 pb-6">
            <!-- Search fields -->
            <v-row class="ma-1">
                    <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="mr-4"
                    style="max-width: 270px;max-height:52px" variant="outlined" color="primary" @keyup.enter="loadData('search')"></v-text-field>
                <v-spacer></v-spacer>
                <v-actions>
                  <v-btn class="mr-2 text-none" variant="flat" :disabaled="selected.length === 0" @click="downloadFile" color="primary" size="x-large">Download</v-btn>          
                  <v-btn class="mr-2 pt-0 text-none" :disabled="selected.length !== 0" size="x-large" variant="flat" color="primary" @click="navigateToFileUpload">Upload</v-btn>
                </v-actions>
            </v-row>
        </v-card-title>        
      </v-card>
      <v-layout column>
        <v-data-table 
            hover
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            :items-per-page="pageSize"
            fixed-header
            height="100%"
            loading-text="Loading Data... Please wait" 
            class="elevation-1"
            return-object
            >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                <span v-if="header.key == 'action'">
                    <v-icon size="large" color="error">mdi-trash-can-outline</v-icon>
                </span> 
                <span v-else-if="header.key !== 'imags' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                    {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                </span>
                <span v-else>-</span>
                </template>
                <template
                    v-for="key in Object.keys(table_data[0]?.approval_details || {})"
                    v-slot:[`item.approval_details.${key}`]="{ item }" :key="key">
                    {{ item.approval_details?.[key] || '-' }}
                </template>
            <template #bottom></template>
        </v-data-table>
    </v-layout>
    <!-- pagination display -->
     <PaginationComponent
             :pageSize="pageSize"
             :pageSizes="pageSizes"
             :totalCount="totalCount"
             :selected="selected"
             :page="page"
             :totalPages="totalPages"
             @update:pageSize="handlePageSizeChange"
             @update:page="handlePageChange"
             class="mt-2 mb-2"
          />
    </v-card>
</template>
<script setup>
import { ref,reactive, onMounted, getCurrentInstance, computed } from 'vue'
import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import CommonDialog from '@/components/commoncomponents/CommonDialog.vue';
import data from '@/components/api/v2/ClientConfigurationMasters/clientData.json';
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router'
    const store = useStore();
    const router = useRouter();
    const route = useRoute();   
    const { proxy } = getCurrentInstance(); 
    const headerText = ref('Rule Engine Profile Master');
    const snackbar = reactive({
        visible: false,
        text: '',
        color: '',
        icon: '',
        timeout: 2000,
        position: 'top',
        mode: 'multi-line'
    })
    const search_tag = ref('');
    const selected = ref([]);
    const table_data = ref([]);
    const loading = ref(false);
    const headers = ref([{title: "Category", key: "category", minWidth: "200px"},
                        {title: "Issue Code", key: "issue_code", minWidth: "200px"},
                        {title: "Issue Description", key: "issue_description", minWidth: "200px"},
                        {title: "", key: "action", minWidth: "200px"}]);
    const search = ref('');
    const page = ref(1);
    const pageSize = defaultPageSize;
    const pageSizes = defaultPageSizes;
    const totalCount = ref(0);
    const totalPages = ref(1);
    onMounted(() => {
        loadData();
    });

    const loadData = () => {
        loading.value = true;
        selected.value = [];
        table_data.value = [];
        page.value = 1;
        totalPages.value = 1;
        
        const params = {
            page: page.value,
            per_page: pageSize.value,
        }
        proxy.$httpSecured
        .get("/api/v2/approval_matrix", { params })
        .then(response => {
          if(response.data) {
            const rows = data.data_validation;
            table_data.value = rows;
            headers.value = [];
            const unique_keys = new Set();
            rows.forEach((row) => {
               Object.keys(row).forEach((key) => {
                   if(key !== "id"){
                       unique_keys.add(key);
                   }
               })
            })
            unique_keys.forEach((key) => {
                headers.value.push({
                    title: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
                    align: 'start',
                    sortable: false,
                    key: key,
                })
            })
            totalPages.value = response.data.meta.total_pages;
            totalCount.value = response.data.meta.total_count;
            loading.value = false;
          }else{
            loading.value = false;
            proxy.$toast.error("No Data Found");
          }
        })
        .catch(error => {
            loading.value = false;
            proxy.$toast.error(error.response.data.message);
        })
    }
    const downloadFile = () => {
        snackbar.visible = true;
        snackbar.color = "success";
        snackbar.icon = "mdi-check-circle";
        snackbar.mode = "multi-line";
        snackbar.position = "bottom";
        snackbar.timeout = 3000;
        snackbar.title = "Success";
        snackbar.text = "(CSV File) Downloaded Successfully";
    }

    const navigateToFileUpload = () => {
         store.commit("setLotIds", {
          lotIds:'',
          inventoryId: headerText.value,
          action:'first_tab'
        });
        store.commit("config/ADD_HEADER", headerText.value);
        router.push({ name: "LotFileuploadComm" });
    }

</script>
<style scoped>
 .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 270px) !important;
 }
</style>
